import {
  ANTIBODIES_ATTACHMENTS_RESOURCE_NAME,
  ANTIBODIES_RESOURCE_NAME,
  ANTIBODIES_DETAIL_RESOURCE_NAME,
  BILLING_CONTACTS_RESOURCE_NAME,
  DROPBOXES_RESOURCE_NAME,
  MULTIPLEX_ANTIBODIES_RESOURCE_NAME,
  NEWSFEED_RESOURCE_NAME,
  ORDER_ANTIBODIES_RESOURCE_NAME,
  ORDER_FIXATIVES_RESOURCE_NAME,
  ORDERS_FILE_ATTACHMENTS,
  ORDERS_PO_UPLOAD_ATTACHMENT,
  ORDERS_QUOTE_ATTACHMENT,
  ORDERS_SAMPLE_SCIENCE_INFO_ATTACHMENT,
  ORGAN_RESOURCE_NAME,
  ORGANIZATION_RESOURCE_NAME,
  PANELS_RESOURCE_NAME,
  PATHOLOGY_MAP_REQUESTED_SLIDE_INFO_RESOURCE_NAME,
  PROJECTS_RESOURCE_NAME,
  SAMPLE_SUBMISSIONS_RESOURCE_NAME,
  SIMPLE_PANELS_RESOURCE_NAME,
  SPECIAL_INSTRUCTIONS_ATTACHMENTS_RESOURCE_NAME,
  SPECIAL_STAINS_RESOURCE_NAME,
  SPECIES_RESOURCE_NAME,
  TEAM_ADDRESSES_RESOURCE_NAME,
  TEAM_RESOURCE_NAME,
  USER_DETAILS_RESOURCE_NAME,
  USER_PREFERENCES_RESOURCE_NAME,
  TEAM_NEWSFEED_RESOURCE_NAME,
  TEAM_MEMBERS_RESOURCE_NAME,
  ORDER_RESOURCE_NAME,
  TEAM_WALLET_TRANSACTIONS_NAME,
  WALLETS,
  ML_MODELS,
} from 'services/resources/apiConstants';
import {
  backendAPI,
  backendServiceDecorator,
  UnauthenticatedAPI,
} from 'services/backendAPI';

export const getGenericResource = (url) =>
  backendAPI.get(url).then((response) => response.data);

export const getAPIUserDetails = () =>
  getGenericResource(USER_DETAILS_RESOURCE_NAME);

export const updateCurrentUserPreferences = (postParams) =>
  backendAPI.post(USER_PREFERENCES_RESOURCE_NAME, postParams);

export const updateAPIUserDetails = (postParams) =>
  backendAPI.post(USER_DETAILS_RESOURCE_NAME, postParams);

export const getOrganizations = () =>
  UnauthenticatedAPI.get(ORGANIZATION_RESOURCE_NAME).then(
    (response) => response.data,
  );

export const createOrganization = (postParams) =>
  UnauthenticatedAPI.post(ORGANIZATION_RESOURCE_NAME, postParams).then(
    (response) => response.data,
  );

export const getProjects = () =>
  backendAPI.get(PROJECTS_RESOURCE_NAME).then((response) => response.data);

export const getTeams = () => backendAPI.get(TEAM_RESOURCE_NAME);

export const getTeamMembers = (teamUUID) => {
  const url = TEAM_MEMBERS_RESOURCE_NAME.replace(':teamUUID', teamUUID);

  return backendAPI.get(url).then((response) => response.data);
};

export const getTeamNewsfeed = (teamUUID, { limit, offset } = {}) => {
  const url = TEAM_NEWSFEED_RESOURCE_NAME.replace(':teamUUID', teamUUID);
  const params = {};

  if (limit != null) {
    params.slide_comments_limit = limit;
  }

  if (offset != null) {
    params.slide_comments_offset = offset;
  }

  return backendAPI.get(url, { params }).then((response) => response.data);
};

export const getUserNewsfeedActivity = () =>
  backendAPI.get(NEWSFEED_RESOURCE_NAME).then((response) => response.data);

export const createProject = (postParams) =>
  backendAPI
    .post(PROJECTS_RESOURCE_NAME, postParams)
    .then((response) => response.data);

export const createFixative = (postParams) =>
  backendAPI
    .post(ORDER_FIXATIVES_RESOURCE_NAME, postParams)
    .then((response) => response.data);

export const getOrgans = () =>
  backendAPI
    .get(ORGAN_RESOURCE_NAME, { cacheEnabled: true })
    .then((response) => response.data);

export const getSpecies = () =>
  backendAPI
    .get(SPECIES_RESOURCE_NAME, { cacheEnabled: true })
    .then((response) => response.data);

export const getSampleSubmissions = (order = undefined) => {
  const requestConfig = {
    params: {
      materials_at_histowiz: !!order?.materials_at_histowiz,
    },
    cacheEnabled: true,
  };

  return backendAPI
    .get(SAMPLE_SUBMISSIONS_RESOURCE_NAME, requestConfig)
    .then((response) => response.data);
};

export const getMultiplexAntibodies = backendServiceDecorator(
  (backendAPIService) =>
    backendAPIService
      .get(MULTIPLEX_ANTIBODIES_RESOURCE_NAME)
      .then((response) => response.data),
);

export const getAntibodies = backendServiceDecorator((backendAPIService) =>
  backendAPIService
    .get(ANTIBODIES_RESOURCE_NAME)
    .then((response) => response.data),
);

export const getAntibody = backendServiceDecorator(
  (backendAPIService, antibodyUUID) =>
    backendAPIService
      .get(
        ANTIBODIES_DETAIL_RESOURCE_NAME.replace(':antibodyUUID', antibodyUUID),
      )
      .then((response) => response.data),
);

export const getOrderAntibodies = (orderUUID) => {
  const url = ORDER_ANTIBODIES_RESOURCE_NAME.replace(':orderUUID', orderUUID);

  return backendAPI.get(url).then((response) => response.data);
};

export const postAntibody = (postParams) =>
  backendAPI
    .post(ANTIBODIES_RESOURCE_NAME, postParams)
    .then((response) => response.data);

export const getSpecialInstructionsAttachments = () =>
  backendAPI
    .get(SPECIAL_INSTRUCTIONS_ATTACHMENTS_RESOURCE_NAME)
    .then((response) => response.data);

export const uploadSpecialInstructionsAttachments = (postParams) =>
  backendAPI.post(SPECIAL_INSTRUCTIONS_ATTACHMENTS_RESOURCE_NAME, postParams);

export const uploadAntibodyAttachments = (postParams) =>
  backendAPI.post(ANTIBODIES_ATTACHMENTS_RESOURCE_NAME, postParams);

export const uploadSampleScienceInfoAttachment = (postParams) => {
  const orderUUID = postParams.get('order_uuid');
  const url = ORDERS_SAMPLE_SCIENCE_INFO_ATTACHMENT.replace(
    ':orderUUID',
    orderUUID,
  );

  return backendAPI.post(url, postParams).then((response) => response.data);
};

export const uploadQuoteAttachment = (postParams) => {
  const orderUUID = postParams.get('order_uuid');
  const url = ORDERS_QUOTE_ATTACHMENT.replace(':orderUUID', orderUUID);

  return backendAPI.post(url, postParams).then((response) => response.data);
};

export const updatePOAttachment = (data) => {
  const orderUUID = data.get('order_uuid');

  const url = ORDERS_PO_UPLOAD_ATTACHMENT.replace(':orderUUID', orderUUID);

  return backendAPI.post(url, data);
};

export const uploadOrderFileAttachments = (postParams) => {
  const orderUUID = postParams.get('order_uuid');
  const url = ORDERS_FILE_ATTACHMENTS.replace(':orderUUID', orderUUID);

  return backendAPI.post(url, postParams).then((response) => response.data);
};

export const getOrderFileAttachments = (orderUUID) => {
  const url = ORDERS_FILE_ATTACHMENTS.replace(':orderUUID', orderUUID);

  return backendAPI.get(url).then((response) => response.data);
};

export const getSpecialStains = () =>
  backendAPI
    .get(SPECIAL_STAINS_RESOURCE_NAME, { cacheEnabled: true })
    .then((response) => response.data);

export const getPanels = backendServiceDecorator((backendAPIService) =>
  backendAPIService.get(PANELS_RESOURCE_NAME).then((response) => response.data),
);

export const getSimplePanels = () =>
  backendAPI.get(SIMPLE_PANELS_RESOURCE_NAME).then(({ data }) => data);

export const getSpecialStainsIHC = backendServiceDecorator(
  (backendAPIService) =>
    backendAPIService
      .get(SPECIAL_STAINS_RESOURCE_NAME, { cacheEnabled: true })
      .then((response) => response.data),
);

export const createPanel = (data) =>
  backendAPI.post(PANELS_RESOURCE_NAME, data).then((response) => response.data);

export const getBillingContacts = () =>
  backendAPI
    .get(BILLING_CONTACTS_RESOURCE_NAME)
    .then((response) => response.data);

export const postBillingContact = (postParams) =>
  backendAPI
    .post(BILLING_CONTACTS_RESOURCE_NAME, postParams)
    .then((response) => response.data);

export const getTeamAddresses = ({ cached } = { cached: false }) =>
  backendAPI
    .get(TEAM_ADDRESSES_RESOURCE_NAME, { cacheEnabled: cached })
    .then((response) => response.data);

export const getTeamWalletTransactions = (teamWalletUUID) => {
  const url = TEAM_WALLET_TRANSACTIONS_NAME.replace(
    ':teamWalletUUID',
    teamWalletUUID,
  );

  return backendAPI.get(url).then((response) => response.data);
};

export const getTeamWallets = () =>
  backendAPI.get(WALLETS).then((res) => res.data);

export const getMLModels = () =>
  backendAPI.get(ML_MODELS).then((res) => res.data);

export const postTeamAddress = (postParams) =>
  backendAPI
    .post(TEAM_ADDRESSES_RESOURCE_NAME, postParams)
    .then((response) => response.data);

export const getCachedGenericResource = (url) =>
  backendAPI.get(url, { cacheEnabled: true }).then((response) => response.data);

export const getDropboxes = () => getGenericResource(DROPBOXES_RESOURCE_NAME);

export const postBuyUnstainedSlide = ({ slide }) => {
  let url = PATHOLOGY_MAP_REQUESTED_SLIDE_INFO_RESOURCE_NAME;
  url = url.replace(':slideUUID', slide.uuid);

  return backendAPI.post(url).then((response) => response.data);
};

export const pullOrderBarcodeLabels = (orderUUID) => {
  const url = `${ORDER_RESOURCE_NAME}${orderUUID}/slide_names.conf`;

  return backendAPI.get(url).then((response) => response.data);
};
